export const lang = {
    lang: 'English',
    lang1: 'Chinese',

    login:{
        OnlineTrainingSystem:"Online training system",
        Login:"Login",
        userName:"User name",
        password:"Password",
        ForgetPassword:"Forget password",
        RegisterNow:"Register now",
        // 
        RetrievePassword:"Retrieve password",
        ReturnLogin:"Return to login",
        EnterName:"Enter one user name",
        Eamil:"Eamil",
        EnterEmail:"Please enter email address",
        vCode:"Verification Code",
        vCodeTxt:"Verification code obtained from mailbox",
        get_vCode:"Get verification code",
        error_vCode:"Verification code error",
        setNewPassword:"Set new password",
        enterPassword:"Please input a password",
        confirmPassword:"Confirm password",
        inconsistentPassword:"The two passwords are consistent",
        Confirm:"Confirm",
        Register:"Register",
        GoLogin:"Existing account? Go login",
        SelectIdentity:"Select identity",
        required:"This is required",
        userName:"User name",
        maxTen:"No more than ten characters",
        setPassword:"Set password",
        checkNo:"The password has at least six digits and can contain letters, symbols or numbers",
        agree:"I have read and agree",
        agreement:"User agreement",
        crew:"crew",
        EngineerTrainee:"Engineer Trainee",
        samePassword:"Please keep the same password twice",
        
        PerfectData:"Perfect data",
        RealName:"Real name",
        requiredName:"This is a required item. Please fill in your real name.",
        Sex:"Sex",
        man:"man",
        woman:"woman",
        retrievePassword:"Used to confirm your identity and retrieve your password.",
        CrewCompany:"Crew company",
        vesselName:"Name of vessel",
        Submit:"Submit",
    },
    // 注册
    Register:{
        check_name:"User name cannot be empty",
        check_email:"Mailbox cannot be empty",
        check_code:"Mailbox cannot be empty",
        check_password:"Password cannot be empty",
        check_password_:"Inconsistent passwords",
        check_agreement:"Please read and agree to the user agreement",
        check_realName:'Real name cannot be empty'

    },

    // 公共
    footer1:'Beijing hailanxin Data Technology Co., Ltd',
    footer2:'security network security',
    Notice:"Notice",
    title:"Beijing hailanxin Data Technology Co., Ltd. entrance!",
    Home:"Home",
    Course:"Course Selection Center",
    Question:"Question bank exercise",
    Personal:"Personal Center",

    // 首页
    home: {
        AllCourses:"All courses",
        SeeMore:"See more",
        enteredFor:"entered for",
        Question:"Question bank exercise",
    },

    // 选课中心
    course: {
        Selection: "Course Selection Center",
        enter:"Please enter the content",
        enteredFor:"entered for",
        CurrentLocation:"Current location:",
        Home:"Home",
        StudyEmploymentGuidanceCourses:"Study employment guidance courses",
        classification:"classification",
        type:"type",
        lecturer:"lecturer",
        hours:"Class hours",
        NumberOfStudents:"Number of students",
        Learned:"Learned",
        LastStudyTime:"Last study time",
        study:"study",
		StartLearning:"Start learning",
        ContinueLearning:"Continue learning",
        RelatedCourses:"Related courses",
        CourseIntroduction:"Course introduction",
        CourseCatalogue:"Course catalogue",
        AfterClassPractice:"After class practice",
        FinalExamination:"Final examination",
        enclosure:"enclosure",
        QA:"Q & A",

        mattersNeedingAttention:"matters needing attention:",
        PassCondition:"Pass condition:",
        ExamExercise:"Exam exercise:",
        text1:"The course can be passed when the average progress of all courseware reaches 100%",
        text2:"There are no exams and exercises in this course",

        CoursewareName:"Courseware name",
        classification:"classification",
		desc:"introduction",
        duration:"duration",
        progress:"progress",
        credit:"credit",
        CurrentPlayback:"Current playback:",
        LastLecture:"Last lecture",
        NextLecture:"Next lecture",

        StartPracticing:"Start practicing",

        examination:"examination",

        AttachmentName: "Attachment name",
        fileSize:"File size",
        UploadTime:"Upload time",

        altogether:"altogether",
        individual:"individual",
        problem:"problem",
        question:"I want to ask a question",
        answer:"answer",
        browse:"browse",
        FromCourse:"From course:",
        Questioner:"Questioner:",
        QuestionTime:"Question time:",

        Describe:"Describe your problem in one sentence, no more than 100 words",
        Cancel:"Cancel",
        Confirm:"Confirm",

        AddAnswer:"Add answer",
        SubmitAnswer:"Submit answer",
        answers:"answers",
        reply:"reply",
        adopt:"adopt",
		Adopted:"Adopted",
        delete:"delete",
		// 
		minute:'minute',
		TotalScore:'Total Score',
		PassingScore:'Passing Score',
		Score:'Score',
		updated_at:'Update time',
		NumberExercises:'Number of exercises',
		TotalNumberQuestions:'Total number of questions',
		QuestionsUnit:'questions',
    },

    // 题库练习
    question:{
        Selection: "Question bank exercise",
        UpdateTime:"Update time:",
        Browse:"Browse:",
		ConfirmSubmit:'Confirm Submit',
		reportTitle:'Your correct rate of this exercise is:',
		reportTxt:"Congratulations, keep up the good work!"
    },

    // 个人中心
    personal:{
        Gender:"Gender:",
        Department:"Department:",
        RegistrationTime:"Registration time:",
        credit:"credit",
        ClassHours:"Class hours",
        CompletedCourse:"Completed course",
        NumberOfExaminations:"Number of examinations",

        BasicInformation:"Basic information",
        MyCourse:"My course",
        MyExam:"My exam",
        MyRrades:"My grades",
        MyRractice:"My practice",
        MyCredits:"My credits",
        MyCertificate:"My certificate",
        MyNews:"My news",
        QA:"My Q & A",

        user: {
            EditData:"Edit data",
            ChangePassword:"Change Password",
            ModifyMailbox:"Modify mailbox",
            edit:"edit",
            RealName:"Real name:",
            Gender:"Gender:",
            male:"male",
            woman:"woman",
            IdentityLnformation:"Identity information:",
            Credits:"Credits:",
            ClassHours:"Class hours:",
            minute:"minute",
            RegistrationTime:"Registration time:",
            LastLoginIP:"Last login IP:",
            LastLoginTime:"Last login time:",
            SetPhotos:"Set photos:",
            UploadAvatar:"Upload Avatar",
            RecommendedSize:"Recommended size:",
            pixel:"pixel",
            preservation:"preservation",

            OldPassword:"Old password:",
            NewPassword:"New password:",
            ConfirmPassword:"Confirm password:",
            VerificationCode:"Verification Code:",

            OldEmailAddress:"Old email address:",
            NewEmailAddress:"New email address:",
            LoginPassword:"Login password:",
        },

        course:{
            RecentLearning:"Recent learning",
            CourseStarted:"Course to be started",
            CompletedCourse:"Completed course",
            courses:"You don't have any courses yet",
            EnterTheCourse:"Enter the course",
        },

        examination:{
            ToTakeTheExam:"To take the exam",
            FailedToPassTheAudit:"Failed to pass the audit",
            Approved:"Approved",
            ExamCompleted:"Exam completed",
            TotalScore:"Total score",
            ApplyForRegistration:"Apply for registration",
			Retest:"Retest",
        },

        report:{
            report:"My report card",
            ExaminationTime:"Examination time:",
            participants:"Number of participants",
            AnswerTime:"Answer time:",
            ViewTestPaper:"View test paper",
            minute:"",
            pass:"pass",
            fail:"fail",
        },

        exercises:{
            MyPractice:"My practice",
            UpdateTime:"Update time:",
            Browse:"Browse:",
            TotalQuestions:"Total number of questions:",
            StartPracticing:"Start practicing",
        },

        gradePoint:{
            MyExam:"My exam",
            TotalCredits:"Total credits:",
            creditSource:"Credit source",
            creditSourceType:"Credit source type",
            GetCredit:"Get credit",
            GetTime:"Get time",
        },

        certificate:{
            MyCertificate:"My certificate",
            TotalCertificates:"Total number of certificates:",
            AddCertificate:"Add new certificate",
            CertificateName:"Certificate name",
            CertificateNo:"Certificate No",
            GetTime:"Get time",
            TermValidity:"Term of validity",
            operate:"operate",
            ViewCertificate:"View Certificate",
            DeleteCertificate:"Delete certificate",

            UploadCertificate:"Upload personal certificate",
            ClickImage:"Click upload certificate image",
            PictureRequirements:"Picture requirements:",
            text1:"1. The recommended picture size is",
            text2:"2. The picture size shall not exceed",
            text3:"3. Picture format is limited to",
            IssuingAuthority:"Issuing authority:",
            ValidityCertificate:"Validity period of certificate:",
            CertificateDescription:"Certificate Description:",
            cancel:"cancel",
            preservation:"preservation",
        },

        message:{
            MyNews:"My news",
            Congratulations:"Congratulations on your course",
            Completed:"Completed,",
            GetCredits:"Get credits",
            Source:"Source:",
            Published:"Published on:",
        },

        questions:{
            MyQuestion:"My question",
            answer:"Answer",
            browse:"Browse",
            sourceCourse:"Source course:",
            Questioner:"Questioner:",
            QuestionTime:"Question time:",
            QA:"My Q & A",
        },

    },

    // 考试
    examination:{
        examinee:"Examinee:",
        Gender:"Gender:",
        belongTo:"Belong to:",
        CertificateNo:"Certificate No:",
        essentialInformation:"Essential information",
        Total:"Total score of test questions:",
        PassingScore:"Passing score:",
        TotalQuestions:"Total number of questions:",
        TotalTime:"Total exam time:",
        minute:"minute",
        examinationExplain:"Examination explain",
        AttentionCandidates:"Attention, candidates:",
        text1:"1. Enter the examination page and click 'start examination' to officially answer the questions;",
        text2:"2. When answering questions, please pay attention to the countdown of the examination page. When the time is over, the system will force the submission of examination papers. Please pay attention to the examination schedule;",
        text3:"3. Please do not switch the screen interface at will during the examination, and the candidates shall be responsible for any consequences;",
        text4:"4. The final examination result shall be subject to the successful submission of the examination paper.",
        text5:"I wish you all good grades!",
        Start:"Start the exam",

        back:"Back",
        submit:"Submit",
        Score:"Score",
        AnswerSheet:"Answer sheet",
        haveFinished:"Have finished",
        unfinished:"Unfinished",
        SubmissionReminder:"Submission reminder",
        txt1:"The total number of questions in this exam is",
        txt2:"You have answered the questions",
        txt3:"Unanswered questions",
        txt4:"Are you sure to submit the test paper?",
        cancel:"Cancel",
        confirm:"Confirm",

        report:{
            result:"Your test result is:",
            Congratulations:"Congratulations, you passed the exam!",
			comfort:"It's a pity that you failed. Go on！",
            Examination:"Examination analysis",
            txt1:"The full score of this test paper is 100 and the passing score is 60.",
            txt2:"1. Single choice questions:",
            txt3:"2. Multiple choice questions:",
			txt4:"3. Judgment question:",
            Total:"Total score:",
            StartTime:"Start time:",
            SubmissionTime:"Submission time:",
            ExaminationTime:"Examination time:",
            minute:"minute",
            second:"second",
            ViewAnswerAnalysis:"View answer analysis",
        },

        analysis:{
            Score:"Score",
            WrongAnswer:"Wrong answer",
            correct:"Correct",
            StudentAnswer:"Student answer:",
            StandardAnswer:"Standard answer:",
            Score1:"Score:",
            Analytic:"Analytic:",
            ExaminationFocus:"Examination focus:",
            AnswerSheet:"Answer sheet",
            correct1:"correct",
            error:"error",
            NotDone:"Not done",
            Your:"Your test result is:",
            Congratulations:"Congratulations, you passed the exam!",
            Back:"Back"
        }
    },
	out: "out",
	Label_classification:'Label classification',
	Course_type:'Course type',
	Course_classification:'Course classification',
	// xx:'xx',
	unit:{
		dao:''
	}
}
